require("./base/jspdf-a11y");
var generator = require("./generate");
var StyleManager = require("./style-manager");
var getBrowserStyles = require("./browser-styles");
var PDFNode = require("./node-types/node");
var PDFFieldNode = require("./node-types/field");
function generate(root, options) {
    if (!options)
        options = {};
    var rootNode = typeof root.getRootNode === "function" ? root.getRootNode() : root.ownerDocument;
    var styles = options.styles || getBrowserStyles(rootNode, options.selectorPrefix, options.stylesheetFilter);
    var styleManager = new StyleManager(styles);
    // console.time("resolveRules");
    styleManager.resolveRules(root);
    // console.timeEnd("resolveRules");
    PDFNode.setCharacterMap(options.characterMap);
    var pdf = generator(root, styleManager, options.compress || false);
    return pdf;
}
module.exports = {
    generate: generate,
    defineField: PDFFieldNode.define,
    getFieldValue: PDFFieldNode.getValue,
};
//# sourceMappingURL=module.js.map